import React from 'react';
import {
	TableCell,
	TableRow,
	Typography,
	Stack,
	Checkbox,
	Tooltip,
	useTheme,
} from '@mui/material';
import { formatCurrency, formatDateDayToYear } from '@/utils/constants';
import { getPolicyTransactionInvoiceLabel } from '@/utils/policyTransactionLabel';

export const InvoiceTransactionRow = ({
	transaction,
	handleCheckboxChange,
	hideCheckbox,
	selected = false,
	showDisabledRow = false,
	isInvoiceRow = false,
}) => {
	const theme = useTheme();
	const debtorPipelineId = process.env.REACT_APP_PIPELINE_DEBTORS;
	// Safely get debtor deals (deal is an array)
	const debtorDeals = Array.isArray(transaction?.deal)
		? transaction.deal.filter((deal) => deal?.pipeline === debtorPipelineId)
		: [];

	const associatedToDebtor = debtorDeals.length > 0;

	const showDisabled = showDisabledRow && associatedToDebtor;

	const tooltipText =
		showDisabled && debtorDeals.length > 0
			? `This invoice has already been associated with a debtor: ${debtorDeals
					.map((deal) => deal?.dealName)
					.filter(Boolean)
					.join(', ')}`
			: '';

	return (
		<Tooltip title={tooltipText} placement='top'>
			<TableRow
				key={`table-row-${transaction?.Id}`}
				sx={{
					...(showDisabled && {
						backgroundColor: theme.palette.action.disabledBackground,
					}),
				}}
			>
				{!hideCheckbox && (
					<TableCell size='small' padding='checkbox'>
						<Checkbox
							checked={transaction?.selected || showDisabled || selected}
							onChange={(event) => handleCheckboxChange(event, transaction?.Id)}
							color='primary'
							disabled={showDisabled}
						/>
					</TableCell>
				)}

				<TableCell width='10%'>
					<Typography>
						{getPolicyTransactionInvoiceLabel(transaction)}
					</Typography>
				</TableCell>

				<TableCell sx={{ whiteSpace: 'wrap' }}>
					<Stack spacing={1}>
						<Typography>{transaction?.PolicyNumber}</Typography>
						<Typography>{transaction?.ClassOfRiskName}</Typography>
					</Stack>
				</TableCell>

				<TableCell>
					<Typography>{transaction?.TransactionType}</Typography>
				</TableCell>

				<TableCell width='15%' sx={{ whiteSpace: 'wrap' }}>
					<Typography>
						{formatDateDayToYear(
							isInvoiceRow
								? transaction?.PolicyEffectiveDate
								: transaction?.PolicyToDate,
						)}
					</Typography>
				</TableCell>
				{!isInvoiceRow && (
					<TableCell>
						<Typography>{transaction?.InsurerName ?? transaction?.Insurer}</Typography>
					</TableCell>
				)}
				{isInvoiceRow && (
					<TableCell>
						{formatCurrency({
							num: transaction?.Balance,
							showDecimal: true,
						})}
					</TableCell>
				)}
			</TableRow>
		</Tooltip>
	);
};
